import React from "react";
import { useWaterBalanceT } from "../useWaterBalanceT";
import "./BalanceSidebar.scss";

const MODOS = [
  { id: "cero", tituloKey: "water_balance_modo_cero_titulo", descKey: "water_balance_modo_cero_desc" },
  { id: "datos", tituloKey: "water_balance_modo_datos_titulo", descKey: "water_balance_modo_datos_desc" },
  { id: "dia0", tituloKey: "water_balance_modo_dia0_titulo", descKey: "water_balance_modo_dia0_desc" },
  { id: "demo", tituloKey: "water_balance_modo_demo_titulo", descKey: "water_balance_modo_demo_desc" },
];

// Barra lateral única: marca + selector de modo + pasos del modo activo,
// todo junto — igual que el <aside> de
// Sustemia_BalanceHidrico_Modulo_ES_v1.html. No son dos piezas separadas:
// el selector de modo y la navegación de pasos viven en el mismo panel
// oscuro y sticky.
export function BalanceSidebar({ modo, onChangeModo, steps, activeStep, onChangeStep }) {
  const t = useWaterBalanceT();

  return (
    <aside className="water-balance-aside">
      <div className="water-balance-aside__brand">
        <b>{t("water_balance_brand_caption")}</b>
      </div>

      <div className="water-balance-aside__modo">
        <div className="water-balance-aside__modo-label">{t("water_balance_modo_pregunta")}</div>
        {MODOS.map((m) => (
          <button
            key={m.id}
            type="button"
            className={`water-balance-aside__modo-btn${modo === m.id ? " on" : ""}`}
            onClick={() => onChangeModo(m.id)}
          >
            <strong>{t(m.tituloKey)}</strong>
            <small>{t(m.descKey)}</small>
          </button>
        ))}
      </div>

      <nav className="water-balance-aside__nav">
        {steps.map((v, i) =>
          v.grpKey ? (
            <div className="water-balance-aside__navlab" key={`grp-${i}`}>
              {t(v.grpKey)}
            </div>
          ) : (
            <button
              key={v.key}
              type="button"
              className={`water-balance-aside__step${activeStep === v.key ? " on" : ""}`}
              onClick={() => onChangeStep(v.key)}
            >
              <em>{v.n}</em>
              <span>
                {t(v.labelKey)}
                <small>{t(v.capKey)}</small>
              </span>
            </button>
          )
        )}
      </nav>
    </aside>
  );
}

export default BalanceSidebar;
